import type { UserType } from "@shared/types";
import { useTranslation } from "react-i18next";
import { RoleSwitchPrompt } from "./role-switch-prompt";

/**
 * Shown on a project page whose side for this user (`role`) is not the
 * active role, with a button that switches to it.
 */
export function ViewingAsBanner({
	role,
	className,
}: {
	role: UserType;
	className?: string;
}): React.JSX.Element {
	const { t } = useTranslation();
	return (
		<RoleSwitchPrompt
			role={role}
			className={className}
			message={t("roleSwitcher.viewingAs", {
				role: t(`roleSession.roleNames.${role}`),
			})}
		/>
	);
}
